import sanitizeHtml from 'sanitize-html';

export const EMPTY_PRINT_VALUE = '–';
export const PRINT_DESCRIPTION_LIMIT = 300;

export const normalizePrintableText = (value?: string | null): string =>
  sanitizeHtml(
    (value || '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/li>/gi, '\n'),
    { allowedTags: [], allowedAttributes: {} },
  )
    .replace(/\s+/g, ' ')
    .trim();

export const truncatePrintableText = (value?: string | null, limit = PRINT_DESCRIPTION_LIMIT): string => {
  const normalized = normalizePrintableText(value);
  if (!normalized) return EMPTY_PRINT_VALUE;
  if (normalized.length <= limit) return normalized;
  return `${normalized.slice(0, limit).trimEnd()}…`;
};

export const renderPrintableValue = (value?: string | number | null): string => {
  if (value === null || value === undefined) return EMPTY_PRINT_VALUE;
  const normalized = String(value).trim();
  return normalized || EMPTY_PRINT_VALUE;
};
